import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const H1 = styled.h1`
  font-size: var(--step-up-3);
`;

export const H2 = styled.h2`
  font-size: var(--step-up-2);
`;

export const H3 = styled.h3`
  font-size: var(--step-down-1);
`;

export const H4 = styled.h4`
  color: var(--purple);
  font-size: var(--step-down-1);
  letter-spacing: 0.75px;
  text-transform: uppercase;
`;

export const H5 = styled.h5`
  color: var(--purple-gray);
  font-size: var(--step-down-1);
  letter-spacing: 0.75px;
  text-transform: uppercase;
`;

export const Subheading = styled.h6`
  color: var(--purple-gray);
  font-size: var(--step-down-1);
  font-weight: 400;
`;

export const Numerical = styled.h1`
  font-size: 3em;
  font-weight: 400;
`;

export const StyledLink = styled.a`
  color: var(--purple);
  cursor: pointer;
  font-size: var(--step-down-1);
  text-decoration: underline;
  transition: opacity 400ms var(--quintOut);
  &:hover {
    opacity: 0.5;
  }
`;

export const StyledReactRouterLink = styled(Link)`
  color: var(--purple);
  cursor: pointer;
  font-size: var(--step-down-1);
  text-decoration: underline;
  transition: opacity 400ms var(--quintOut);
  &:hover {
    opacity: 0.5;
  }
`;



// WEBPACK FOOTER //
// ./src/components/base/Text.js